/**
 * Replaces fieldToRemove with fieldToAdd when used with our viewTranslator.
 * Performs no processing to tidy the value stored at the field.
 *
 * @param {string} fieldToRemove Field to remove.
 * @param {string} fieldToAdd New name to store data that was stored at fieldToRemove.
 * @returns {(result: Record<string, unknown>, value: unknown) => Record<string, unknown>} A function to set the value of a field for some JSON value
 *
 */
export var simpleMapper = function (fieldToRemove, fieldToAdd) { return function (result, value) {
    result[fieldToAdd] = value;
    delete result[fieldToRemove];
    return result;
}; };
//# sourceMappingURL=simpleMapper.js.map